export const banksPage = [
  {
    id: 13,
    name: '101% Banco, Banco Comercial, C.A.',
    code: '0156',
    literalCode: '',
    photo:
      'https://d1acjyver5bv2w.cloudfront.net/wallet/bank/89ab6518-0ddd-4ef8-b484-759afe3f419a.png',
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 24,
    name: 'Bamfanb',
    code: '0177',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 20,
    name: 'Bancamiga Banco Universal, C.A.',
    code: '0172',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 19,
    name: 'Banco Activo C.A., Banco Universal',
    code: '0171',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 16,
    name: 'Banco Agrícola de Venezuela C.A., Banco Universal',
    code: '0166',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 7,
    name: 'Banco Caroni C.A., Banco Universal',
    code: '0128',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 1,
    name: 'Banco de Venezuela, S.A. Banco Universal',
    code: '0102',
    literalCode: '',
    photo:
      'https://d1acjyver5bv2w.cloudfront.net/wallet/bank/ec0d03db-e8df-43a8-b755-26a2b713e881.png',
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 5,
    name: 'Banco del Caribe C.A., Banco Universal Bancaribe',
    code: '0114',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 15,
    name: 'Banco del Tesoro C.A., Banco Universal',
    code: '0163',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 25,
    name: 'Banco Digital Banco Microfinanciero',
    code: '0178',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 23,
    name: 'Banco Digital del Trabajador, Banco Universal C.A.',
    code: '0175',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 6,
    name: 'Banco Exterior C.A., Banco Universal',
    code: '0115',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 12,
    name: 'Banco Fondo Com£n, C.A. Banco Universal',
    code: '0151',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 21,
    name: 'Banco Internacional de Desarrollo C.A., Banco Universal',
    code: '0173',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 3,
    name: 'Banco Mercantil C.A., Banco Universal',
    code: '0105',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 26,
    name: 'Banco Nacional de Crédito C.A., Banco Universal',
    code: '0191',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 10,
    name: 'Banco Plaza, Banco Universal',
    code: '0138',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 4,
    name: 'Banco Provincial, S.A. Banco Universal',
    code: '0108',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 9,
    name: 'Banco Sofitasa Banco Universal, C.A.',
    code: '0137',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 2,
    name: 'Banco Venezolano de Crédito, S.A. Banco Universal',
    code: '0104',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 17,
    name: 'Bancrecer S.A., Banco Microfinanciero',
    code: '0168',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 8,
    name: 'Banesco Banco Universal, C.A.',
    code: '0134',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 11,
    name: 'Bangente',
    code: '0146',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 22,
    name: 'Banplus Banco Universal, C.A.',
    code: '0174',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 27,
    name: 'Binance Pay',
    code: 'BP',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: false
  },
  {
    id: 14,
    name: 'DelSur, Banco Universal Banco de Venezuela, C.A.',
    code: '0157',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 18,
    name: 'Mi Banco, Banco Microfinanciero, C.A.',
    code: '0169',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: true
  },
  {
    id: 28,
    name: 'Zelle',
    code: 'ZELLE',
    literalCode: '',
    photo: null,
    priority: 0,
    active: true,
    origin: false
  }
]
